import { supplierServices } from 'src/services/reservation/supplier/supplier.service'

export const getSupplierByProduct = async (product: any) => {
  try {
    if (product) {
      const params = {
        operator: 'equal',
        product_type_id: product?.product_relation?.product_type_id || product?.product?.product_type_id,
        limit: 999,
        is_active: true,
      }
      const suppliers = await supplierServices.getByParam(params)
      return suppliers
    }

    return []
  } catch (error) {
    return []
  }
}
